import { Injectable } from '@angular/core';
import { CookieService, EnvironmentService } from '@dch/ng-common';
import {
  BILL_AUTH_COOKIE_KEY,
  BILL_AUTH_MPXS_COOKIE_VALUE,
  SMOOTH_AUTHENTICATION_SESSION_STORAGE_KEY,
} from '../my-bill/config/my-bill.constants';
import { HTTP_CONSTANTS } from '@dch/entity-manager';
import { jwtDecode, JwtPayload } from 'jwt-decode';
import { Router } from '@angular/router';

@Injectable()
export class MyProximusAuthenticationCheckGuard {
  constructor(
    private environmentService: EnvironmentService,
    private router: Router,
    private cookieService: CookieService
  ) {}

  canActivate(): boolean {
    if (
      this.environmentService.isSmoothAccess &&
      (this.isSmoothAccessRequiredSessionStorageDataNotFound() ||
        BILL_AUTH_MPXS_COOKIE_VALUE ===
          this.cookieService.getCookie(BILL_AUTH_COOKIE_KEY))
    ) {
      window.location.assign(
        window.location.href.replace('/smoothAccess', '/myproximus')
      );
      return false;
    } else if (
      this.environmentService.isSmoothAccess &&
      this.isSmoothAccessTokenExpired()
    ) {
      sessionStorage.removeItem(
        HTTP_CONSTANTS.X_APPLICATION_AUTHORIZATION_HEADER
      );
      this.router.navigate(['/expiredToken']);
      return false;
    }
    return true;
  }

  private isSmoothAccessRequiredSessionStorageDataNotFound(): boolean {
    return (
      sessionStorage.getItem(SMOOTH_AUTHENTICATION_SESSION_STORAGE_KEY) === null
    );
  }

  private isSmoothAccessTokenExpired(): boolean {
    const token = sessionStorage.getItem(
      HTTP_CONSTANTS.X_APPLICATION_AUTHORIZATION_HEADER
    );
    if (token === null) {
      return true;
    }
    try {
      const decoded = jwtDecode<JwtPayload>(token);
      const decodedTokenExpiryTime = decoded?.exp;
      if (typeof decodedTokenExpiryTime !== 'number') {
        // If the token does not have an exp claim, treat it as expired
        return true;
      }
      const currentTime = Date.now() / 1000;
      return decodedTokenExpiryTime < currentTime;
    } catch (e) {
      return true; // Treat malformed token as expired
    }
  }
}
